import React from 'react';
import {inject, observer} from 'mobx-react';
import ClientsListView from '../clients/list-view';
import {userCarsEdit} from '../../../helpers/api';
import {Route} from 'react-router-dom';
import {dateFormatter, formatPassTime, passDurationText, passStatusFormatter} from '../clients/helpers';
import {mosPropNames} from '../clients/dictionaries/prop-names';
import {BaseClientsList} from '../clients/base-list';
import {UserCarsAdd} from './user-cars-add';
import {UserCarsActions} from './user-cars-actions';

@inject("userCarsStore")
@inject("loginStore")
@observer
export default class UserCars extends BaseClientsList {
  page = 'lk';

  renderContent() {
    const lastPass = (property) => {
      return {
        formatter: ({ row, col }) => {
          const pass = col.isNight ? row.night_lastPass : row.lastPass;
          return pass && pass[property];
        },
        key: 'lastPass.' +  property
      };
    };

    const defaults = {
      sort: 'string',
      filterType: 'string'
    };

    const columns = {
      cid: { sort: 'number', width: 40, editable: true  },
      number: { editable: true },
      'lastPass.series': { ...lastPass('series') },
      passTime: { formatter: formatPassTime },
      'lastPass.duration': { formatter: () => passDurationText },
      'lastPass.type': { ...lastPass('type'), width: 50 },
      'lastPass.status': { formatter: passStatusFormatter, filterType: 'passStatus', sort: 'passStatus' },
      'lastPass.createdAt': {
        sort: 'number',
        filterType: 'date',
        formatter: () => dateFormatter,
      },
      'lastPass.endsAt': {
        sort: 'number',
        filterType: 'date',
        formatter: () => dateFormatter,
      },
      note: { editable: true },
    };


    const splitedCols = [
      'lastPass.series', 'passTime', 'lastPass.duration', 'lastPass.type', 'lastPass.status', 'lastPass.createdAt',
      'lastPass.endsAt', 'consideration', 'considerationTemp', 'creatorName', 'price', 'paymentType', 'paymentStatus'
    ];

    const cols = Object.keys(columns)
      .map(i => ({
        key: i,
        ...defaults,
        ...columns[i],
        name: mosPropNames[i],
        splited: splitedCols.includes(i)
      }))
      .filter(col => col.enabled !== false);

    let { items } = this.props.userCarsStore;


    this.applyColSettings(cols);

    return (
      <div id="clients">
        <ClientsListView
          ref="listview"
          page={'req'}
          user={this.props.loginStore.user.user}
          columns={cols}
          items={items}
          onChangeChecked={::this.onChangeChecked}
          onChangeEditableField={::this.onChangeEditableField}
          onChangeColSize={this.onChangeColSize.bind(this, cols)}
          onClickAction={::this.onClickAction}
        />

        <Route path="/user/cars/add" component={(props) => <UserCarsAdd {...props} />}/>
      </div>
    );
  }



  renderActions() {
    return (
      <UserCarsActions
        hasSelected={true}
        onRemoveSelected={::this.removeSelected}
        onCheckSelected={::this.checkSelected}
        onExport={::this.exportSelected}
        onMoveUp={::this.moveUp} />
    );
  }


  renderTitle() {
    const checked = this.refs.listview && this.refs.listview.state.checked;
    const selectedIds = checked ? Object.keys(checked).filter(i => checked[i]) : [];

    if (selectedIds.length) {
      return <h2>Выбрано: {selectedIds.length} ТС</h2>;
    }

    return '';
  }

  async editRow(row, data) {
    return userCarsEdit({ id: row.id, ...data });
  }

  async checkRow(row) {
    return this.props.userCarsStore.check(row);
  }

  async removeRows(ids) {
    return this.props.userCarsStore.remove(ids);
  }

  get clients() {
    return this.props.userCarsStore.items;
  }

  async __reorder(current, next) {
    return await this.props.userCarsStore.reorder(current, next);
  }

  async __orderUp(numbers) {
    return this.props.userCarsStore.orderUp(numbers);
  }


  async __move(numbers, to) {
    throw new Error('move not allowed here');
  }

  async __setSendSms(numbers, state) {
    throw new Error('setSms not allowed here');
  }

  async __export(numbers) {
    await this.props.userCarsStore.export(numbers);
  }

  __loadItems() {
    this.props.userCarsStore.loadAll();
  }

  get __isLoadingItems() {
    return this.props.userCarsStore.isLoadingClients;
  }

  get __store() {
    return this.props.userCarsStore;
  }


}



// WEBPACK FOOTER //
// ./src/components/pages/user/user-cars.js